"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const decode_access_token_1 = require("./utils/decode-access-token");
const validate_token_header_1 = require("./utils/validate-token-header");
const validate_token_claims_1 = require("./utils/validate-token-claims");
const validate_token_with_graph_api_1 = require("./utils/validate-token-with-graph-api");
/**
 * Validate azure active directory access token
 *
 * @param accessToken - valid access token received from azure
 * @param validationOptions - the interface represents required fields to process access token validation
 *
 * @public
 */
async function validate(accessToken, { scopes, audience, tenantId, applicationId }) {
    if (Array.isArray(scopes) && scopes.length === 0) {
        throw new Error('"scopes" array cannot be empty');
    }
    if (typeof audience !== 'string' || audience.length === 0) {
        throw new Error('"audience" value was not provided');
    }
    if (typeof tenantId !== 'string' || tenantId.length === 0) {
        throw new Error('"tenantId" value was not provided');
    }
    if (typeof applicationId !== 'string' || applicationId.length === 0) {
        throw new Error('"applicationId" value was not provided');
    }
    const decodedAccessToken = decode_access_token_1.decodeAccessToken(accessToken);
    if (!decodedAccessToken) {
        throw new Error('The access token could not be decoded');
    }
    await validate_token_header_1.validateTokenHeader(decodedAccessToken.header, tenantId, applicationId);
    validate_token_claims_1.validateTokenClaims(decodedAccessToken.payload, {
        scopes,
        audience,
        tenantId,
        applicationId,
    });
    await validate_token_with_graph_api_1.validateTokenWithGraphApi(accessToken, decodedAccessToken.payload);
    return decodedAccessToken;
}
exports.default = validate;
